import React, { PureComponent, Fragment } from 'react'
import { array, bool, func, number, object, shape, string } from 'prop-types'
import { OrderItem } from '../index'
import { Button, SimpleAsyncButton } from '@ynap/button'
import BEMHelper from '@ynap/bem-helper'
import Notification from '@ynap/notification'
import OrderItemSkeleton from '../OrderItemSkeleton/OrderItemSkeleton'
import Skeleton from '@ynap/skeleton'
import { ToggleSection } from '@ynap/toggle'
const bem = new BEMHelper('OrderHistory')

export default class OrdersSection extends PureComponent {
    static propTypes = {
        bemClassName: string,
        category: string,
        clearStateOnMount: bool,
        fetchOrderHistory: func.isRequired,
        fetchOrderHistoryError: object,
        isFetchingOrderHistory: bool.isRequired,
        messages: shape({
            orderHistory: shape({
                title: func.isRequired,
                description: func.isRequired,
                noOrdersTitle: func.isRequired,
                noOrdersDescription: func.isRequired,
                paginationDetails: func.isRequired,
                loadMore: func.isRequired,
                noOrdersLinkTitle: func.isRequired,
                errorLoadingMoreOrders: func.isRequired,
                pageError: func.isRequired,
                retryButton: func.isRequired,
            }),
        }),
        noOrdersLink: string,
        description: string,
        orders: shape({
            items: array,
            pagination: shape({
                totalOrders: number,
                shouldDisplayLoadMore: bool,
                currentPage: number,
                totalOrdersDisplayed: number,
            }),
        }),
        pageSize: number,
        skeletonOrders: number,
        showExchangeDerivedOrderIds: bool,
        startsOpen: bool,
    }

    constructor(props) {
        super()
        this.state = {
            isOpen: props.startsOpen,
        }

        this.toggleOpen = this.toggleOpen.bind(this)
        this.loadMoreOrders = this.loadMoreOrders.bind(this)
    }

    componentDidMount() {
        const { fetchOrderHistory, pageSize, category } = this.props
        fetchOrderHistory(1, pageSize, category, true)
    }

    toggleOpen() {
        this.setState({ isOpen: !this.state.isOpen })
    }

    loadMoreOrders() {
        const { category, fetchOrderHistory, orders, pageSize } = this.props
        const { pagination } = orders
        const pageNumber = pagination && pagination.currentPage ? pagination.currentPage + 1 : 1
        fetchOrderHistory(pageNumber, pageSize, category, pageNumber === 1)
    }

    render() {
        const {
            category,
            bemClassName,
            orders,
            messages,
            fetchOrderHistoryError,
            isFetchingOrderHistory,
            skeletonOrders,
            description,
            showExchangeDerivedOrderIds,
        } = this.props

        const title = messages.orderHistory[category + 'Orders']({
            totalOrders: orders.pagination.totalOrders,
            error:
                typeof orders.pagination.totalOrders === 'undefined' ||
                isFetchingOrderHistory[category] ||
                fetchOrderHistoryError[category],
        })

        const error = fetchOrderHistoryError[category]

        const canOpen = !orders.items || orders.pagination.totalOrders > 0 || isFetchingOrderHistory[category] || error
        const open = canOpen && this.state.isOpen

        const shouldRenderSkeleton =
            !error &&
            (typeof orders.pagination.totalOrders == 'undefined' ||
                (orders.pagination.totalOrders == 0 && isFetchingOrderHistory[category]))

        return (
            <ToggleSection
                className={bem(bemClassName, !this.state.isOpen ? 'closed' : undefined)}
                title={title}
                type="heading"
                description={description}
                onToggle={this.toggleOpen}
                open={open}
            >
                {!error && orders.items ? (
                    <div className={bem('pagination')}>
                        {messages.orderHistory.paginationDetails({
                            totalOrdersDisplayed: orders.pagination
                                ? orders.pagination.totalOrdersDisplayed
                                : undefined,
                            totalOrders: orders.pagination ? orders.pagination.totalOrders : undefined,
                        })}
                    </div>
                ) : null}

                {shouldRenderSkeleton ? (
                    <Fragment>
                        <Skeleton containerClassName={bem('skeletonStatus')} />
                        <div className={bem('orderList')}>
                            {Array(skeletonOrders)
                                .fill()
                                .map((ignore, i) => (
                                    <OrderItemSkeleton key={i} />
                                ))}
                        </div>
                    </Fragment>
                ) : (
                    <Fragment>
                        {error ? null : orders.pagination && orders.pagination.shouldDisplayLoadMore ? (
                            <>
                                <div className={bem('orderList')}>
                                    {orders.items &&
                                        orders.items.map((o, i) => (
                                            <OrderItem
                                                key={o.externalOrderID ? o.externalOrderID : i}
                                                {...o}
                                                messages={messages}
                                                category={category}
                                                showExchangeDerivedOrderIds={showExchangeDerivedOrderIds}
                                            />
                                        ))}
                                </div>
                                <div className={bem('loadMoreContainer')}>
                                    <SimpleAsyncButton
                                        className={bem('loadMore')}
                                        type="secondary"
                                        onClick={() => this.loadMoreOrders()}
                                        copy={messages.orderHistory.loadMore()}
                                        loading={isFetchingOrderHistory[category]}
                                    />
                                </div>
                            </>
                        ) : (
                            <div className={bem('orderList')}>
                                {orders.items &&
                                    orders.items.map((o, i) => (
                                        <OrderItem
                                            key={o.externalOrderID ? o.externalOrderID : i}
                                            {...o}
                                            messages={messages}
                                            category={category}
                                            showExchangeDerivedOrderIds={showExchangeDerivedOrderIds}
                                        />
                                    ))}
                            </div>
                        )}
                    </Fragment>
                )}

                {error ? (
                    <Notification
                        type="error"
                        message={messages.orderHistory.errorLoadingMoreOrders()}
                        inlineAction={true}
                    >
                        <Button
                            type="primary-link"
                            className={bem('inlineErrorAction')}
                            onClick={() => this.loadMoreOrders()}
                        >
                            {messages.orderHistory.retryButton()}
                        </Button>
                    </Notification>
                ) : null}
            </ToggleSection>
        )
    }
}
